import React from 'react';
import { useIntl } from 'react-intl';
import styles from './style.cssmodule.css';

function ContactLinks() {
  const { formatMessage: t } = useIntl();
  return (
    <React.Fragment>
      <a href={`mailto:${t({ id: 'info.supportEmail' })}`}>
        <b>
          {t({ id: 'info.supportEmail' })}
        </b>
      </a>
      <span className={styles.linkSeparator}>|</span>
      <a href={`tel:${t({ id: 'info.supportPhoneNumber' })}`}>
        {t({ id: 'info.supportPhoneNumber' })}
      </a>
    </React.Fragment>
  );
}

export default ContactLinks;



// WEBPACK FOOTER //
// ./components/templates/AuthenticationLayout/components/ContactLinks/ContactLinks.jsx